import React from 'react';
import ClipboardButton from '../../../../lib/components/form/ClipboardButton';

const DetailsTab = props => {
    const generateXmlConfig =  () => {
        var { actions, encoder } = props;
        actions.getXMLConfigURI({ encoderID: encoder.encoderID });
    }

    const defaultMsg = "Not Available";
    var { encoder } = props;

    return (<div className="col-xs-12 tab-content">
        <div className="col-md-12 form-elements">
            <div className="col-sm-8">
                <label>Server:</label>
                <input className="form-control" type="text" defaultValue={encoder.inputServer || defaultMsg} readOnly/>
            </div>
            <span id="application-input-box">
                <span/>
            </span>
            <div className="col-sm-4">
                <label>Application:</label>
                <input className="form-control" type="text" defaultValue={encoder.applicationName || defaultMsg} readOnly/>
            </div>

            <div className="col-md-4">
                <label>Stream Name:</label>
                <input className="form-control" type="text" name="streamName" value={encoder.streamName || defaultMsg} readOnly/>
            </div>
            <div className="col-md-4">
                <label>User Name:</label>
                <input className="form-control" type="text" defaultValue={encoder.authUser || defaultMsg} readOnly/>
            </div>
            <div className="col-md-4">
                <label>Password:</label>
                <input className="form-control" type="text" defaultValue={encoder.authPass || defaultMsg} readOnly/>
            </div>
            <div className='col-md-4'>
                <label>Encoder ID</label>
                <ClipboardButton value={encoder.encoderID} style={{ position:'absolute', right: '1em', top: '1.5em' }}/>
                <input className='form-control' type='text' defaultValue={encoder.encoderID} readOnly/>
            </div>
        </div>
    </div>);
}

export default DetailsTab;
